/**
 * 微信操作模块
 * @module weixin
 */

import { $isWechat } from "./env";

/**
 * 隐藏分享工具栏
 * @method hideOptionMenu
 */
export function hideOptionMenu() {
  if (!$isWechat) return;
  document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
    window.WeixinJSBridge.call('hideOptionMenu');
  });
}

/**
 * 显示分享工具栏
 * @method showOptionMenu
 */
export function showOptionMenu() {
  if (!$isWechat) return;
  document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
    window.WeixinJSBridge.call('showOptionMenu');
  });
}

/**
 * 隐藏底部导航栏
 * @method hideToolbar
 */
export function hideToolbar() {
  if (!$isWechat) return;
  document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
    window.WeixinJSBridge.call('hideToolbar');
  });
}

/**
 * 显示底部导航栏
 * @method showToolbar
 */
export function showToolbar() {
  if (!$isWechat) return;
  document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
    window.WeixinJSBridge.call('showToolbar');
  });
}
export default {
  hideOptionMenu: hideOptionMenu,
  showOptionMenu: showOptionMenu,
  hideToolbar: hideToolbar,
  showToolbar: showToolbar
};